import { render } from "./MessageDetail.vue?vue&type=template&id=7fbe8246&scoped=true"
import script from "./MessageDetail.vue?vue&type=script&lang=js"
export * from "./MessageDetail.vue?vue&type=script&lang=js"

import "./MessageDetail.vue?vue&type=style&index=0&id=7fbe8246&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fbe8246"]])

export default __exports__